// The access token lives in memory only: it dies with the tab, and no script
// can lift it from storage. The refresh token never reaches JS at all — the
// backend keeps it in an HttpOnly cookie, and `refreshAccessToken()` (axios.ts)
// trades that cookie for a new access token on boot and on every 401.
let accessToken: string | null = null;

// Tokens were once persisted here; purge any a previous build left behind.
const LEGACY_KEYS = ["auth_token", "auth_refresh_token"];
try {
  LEGACY_KEYS.forEach((key) => localStorage.removeItem(key));
} catch {
  // Storage unavailable (private mode) — nothing was persisted then either.
}

const getToken = () => accessToken;

const setToken = (token: string) => {
  accessToken = token;
};

const resetToken = () => {
  accessToken = null;
};

export const auth = {
  getToken,
  setToken,
  resetToken,
};
